<template>
  <div v-loading="loading">
    <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px" label-position="left" size="medium">
      <div class="apply-form-wrap">
        <h4>个人信息</h4>
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名:">{{ userInfo.name }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学号:">{{ userInfo.idnumber }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级:">{{ userInfo.className }}</el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="手机:" prop="phone" :rules="[{ required: true, message: '请输入手机' }]">
              <el-input v-model="form.phone" placeholder="请输入手机" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="apply-form-wrap">
        <h4>相关证明</h4>
        <el-form-item label-width="0">
          <el-radio-group v-model="form.evidence_type">
            <el-row>
              <el-col :span="8">
                <el-radio label="1">在线填写证明人</el-radio>
              </el-col>
              <el-col :span="8">
                <el-radio label="2">上传扫描件</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </el-form-item>
        <el-row class="prove">
          <el-col v-if="+form.evidence_type === 1" :span="8" class="prove-form">
            <el-form-item label="证明人：" prop="evidence_name" :rules="[{ required: true, message: '请输入证明人姓名' }]">
              <el-input v-model="form.evidence_name" placeholder="请输入证明人姓名" :disabled="form.evidence_type !== '1'" size="medium" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机：" prop="evidence_phone" :rules="[{ required: true, message: '请输入证明人手机号码' }]">
              <el-input v-model="form.evidence_phone" placeholder="请输入证明人手机号码" :disabled="form.evidence_type !== '1'" size="medium" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="+form.evidence_type === 2" :span="24" class="prove-image" :class="{ disabled: form.evidence_type !== '2' }">
            <ming-upload type="default" :headimg.sync="form.evidence_file" :congfig="{ limit: 1, accept: `.png,.jpeg,.jpg,.pdf,.docx,.doc`,maxfileSize:3 }" :is-keep-source-file-name="true" />
          </el-col>
        </el-row>
      </div>
      <div class="apply-form-wrap">
        <h4>课程情况</h4>
        <el-row>
          <el-col :span="16">
            <el-form-item label="课程名称：" prop="[course][name]" :rules="[{ required: true, message: '请选择课程' }]">
              <el-input v-model="form.course.name" readonly placeholder="请选择课程" style="width: 70%; margin-right: 10px" size="medium"></el-input>
              <el-button type="primary" size="medium" @click="showCourseSelectDialog = true">选择</el-button>
            </el-form-item>
          </el-col>
          <template v-if="form.course.name">
            <el-col :span="8">
              <el-form-item label="课程编号：">{{ form.course.code }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课程性质：">{{ form.course.nature }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课班级：">{{ form.course.class }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学分：">{{ form.course.credit }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学时：">{{ form.course.class_hours }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学年：">{{ form.course.schoolYear }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="学期：">{{ form.course.semester }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考试时间：">{{ form.course.examTime || '-' }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="考试地点：">{{ form.course.examPlace || '-' }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-input v-model="form.apply_reason" type="textarea" rows="5" placeholder="请输入申请原因" :autosize="{ minRows: 3, maxRows: 6 }" />
            </el-col>
          </template>
        </el-row>
      </div>
      <el-form-item label-width="0">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" :loading="isloading" @click="applySubmit">提交</el-button>
      </el-form-item>
    </el-form>

    <!-- 选择课程弹窗 -->
    <course-select-dialog :visible.sync="showCourseSelectDialog" :type="type" @checkSubmit="selectCourse" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import MingUpload from '@/components/MingUpload'
import CourseSelectDialog from '../../components/CourseSelectDialog'
import { courseApplyHook } from '@/hooks/courseApplyFormHook'
import { Message } from 'element-ui'
import API from '@/api'
import Router from '@/router'
const { userInfo, loading, formRules, cancelSubmit } = courseApplyHook()
const showCourseSelectDialog = ref(false)
const isloading = ref(false)
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  type: {
    type: Number,
    default: () => 0
  }
})
const form = ref({
  phone: '', // 手机

  apply_ct_id: '', // 申请课程id
  apply_reason: '', // 申请理由
  apply_type: '', // 申请类型
  evidence_type: '1', // 相关证明类型：1. 在线 2. 上传
  evidence_name: '', // 当evidence_type = 1时候，必填，证明人姓名
  evidence_phone: '', // 当evidence_type = 1时候，必填，证明人电话
  evidence_file: '', // 当evidence_type = 2时候，必填，证明文件
  course: { name: '' }
})

form.value.phone = Router.currentRoute.query.m

function selectCourse(course) {
  showCourseSelectDialog.value = false
  form.value.course = course.value
  form.value.apply_ct_id = course.value.ctId
}

function applySubmit() {
  submit(form.value)
}
const formRef = ref()
function submit(formData) {
  const {
    params: { typeid }
  } = Router.currentRoute
  formData.apply_type = typeid

  formRef.value.validate(valid => {
    if (valid) {
      isloading.value = true
      API.MBACourseChangeApply(formData)
        .then(res => {
          if (+res.code === 200) {
            Message.success(res.msg)
            Router.replace({ name: 'ApplyAdjustment' })
          } else {
            Message.error(res.msg)
          }

          isloading.value = false
        })
        .catch(_ => {
          isloading.value = false
        })
    } else {
      console.log('error submit!!')
      return false
    }
  })
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
.apply-form-wrap {
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 30px;

  h4 {
    margin-bottom: 17px;
  }

  :deep(.el-input) {
    width: 230px;
  }

  :deep(.el-radio-group) {
    width: 100%;
  }

  :deep(.avatar-uploader),
  :deep(.avatar-uploader-icon) {
    width: 180px;
    height: 100px;
    line-height: 100px;
  }

  :deep(.el-textarea .el-textarea__inner) {
    resize: none;
  }

  .prove-image {
    margin-bottom: 20px;
    &.disabled {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 88;
        display: block;
        width: 180px;
        height: 100px;
        background-color: rgba(245, 247, 250, 0.4);
        cursor: not-allowed;
        filter: grayscale(1);
      }
    }
  }
}
</style>
